import axios from "../../utils/axios";

export async function getPosts(filter = "all", sort = "") {
  let queryString = "";
  let filterString = "";
  let sortString = "";

  if (filter === "saved") filterString = "isSaved=true";
  if (sort === "newest") sortString = "_sort=createdAt";
  if (sort === "most_liked") sortString = "_sort=likes";

  if (filter === "all" && sort === "") {
    queryString = "/blogs";
  } else if (filter === "all" && !!sort) {
    queryString = "/blogs?" + sortString;
  } else {
    queryString = "blogs?" + sortString + "&" + filterString;
  }

  const response = await axios.get(queryString);

  if (filter !== "all") {
    return response.data.reverse();
  }
  if (sort !== "") {
    return response.data.reverse();
  }
  return response?.data;
}
